// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2T6MM","title":"styles_title__11Pq8","buttonsWrapper":"styles_buttonsWrapper__2qf0j"};